var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',{attrs:{"grid":_vm.grid}})
}
var staticRenderFns = []

export { render, staticRenderFns }